import Link from 'next/link';
import { ExternalLink } from 'lucide-react';
import Image from 'next/image';
import { ReactNode } from 'react';

import { PageLayoutBase } from '../utils/types';
import { Toaster } from '../ui/toaster';

export default function PublicPageLayout({
  children,
  CTAContent,
}: PageLayoutBase & { CTAContent?: ReactNode }) {
  const date = new Date();

  return (
    <>
      <div className="bg-white dark:bg-boxdark-2 dark:text-bodydark p-2 md:p-5 flex flex-col md:flex-row gap-5 md:gap-10 min-h-svh">
        <div className="w-full md:1/2 lg:w-2/5 rounded-3xl bg-primary dark:bg-boxdark bg-logo bg-no-repeat bg-bottom-right md:overflow-hidden p-10 md:p-15 flex flex-col justify-between gap-4">
          <div>
            <Link href="/">
              <Image
                src={'/logos/bwth-logo-light.svg'}
                alt="Logo"
                width={185}
                height={40}
              />
            </Link>
            {CTAContent && <div className="mt-4 md:mt-28">{CTAContent}</div>}
          </div>

          <div className="flex gap-2 flex-col xl:flex-row">
            <p>
              © {date.getFullYear()} Black Women in Tech Hub, All rights
              reserved.
            </p>

            <Link
              className="cta-link flex gap-1"
              href="https://bwbntechhub.com/"
            >
              bwbntechhub.com <ExternalLink />
            </Link>
          </div>
        </div>
        {children && (
          <div className="w-full md:1/2 lg:w-3/5 px-8 lg:px-15 md:overflow-auto flex flex-col justify-center h-full self-center">
            <div className="flex flex-col w-full max-w-4xl py-5 md:py-10 self-center">
              {children}
            </div>
          </div>
        )}
      </div>
      <Toaster />
    </>
  );
}
